const KEY = "fit2lift:adminOrgList";

export type AdminOrgListContext = "leads" | "clients";

export function setAdminOrgListContext(ctx: AdminOrgListContext): void {
  try {
    sessionStorage.setItem(KEY, ctx);
  } catch {
    /* ignore */
  }
}

export function getAdminOrgListContext(): AdminOrgListContext {
  try {
    const v = sessionStorage.getItem(KEY);
    return v === "leads" ? "leads" : "clients";
  } catch {
    return "clients";
  }
}

export function adminListPathForContext(): "/admin/leads" | "/admin/clients" {
  return getAdminOrgListContext() === "leads" ? "/admin/leads" : "/admin/clients";
}
